import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/images/logo.png';
import '../styles/styles.css';

function Inicio() {
  useEffect(() => {
    document.body.classList.add('body-inicio');

    // document.body.style.cursor = "url('/cursors/cursor.png') 0 0, auto";


    return () => {
      document.body.classList.remove('body-inicio');
      document.body.style.cursor = "auto";
    };
  }, []);

  return (
    <section className="inicio-section">
      <div className="inicio-box">
        <img src={Logo} alt="Logo" className="inicio-logo" />
        <h1 className="inicio-titulo">Hola, soy Fabianna</h1>
        <p className="inicio-subtitulo">
          Transformo tu idea en justo lo que estás buscando.<br />
          Explora mi portafolio y contáctame.
        </p>

        <p className="intro-line">
          Diseño limpio. Código funcional. Experiencias centradas en el usuario.
        </p>

        <nav className="inicio-nav">
          <Link to="/sobre-mi" className="inicio-link">Sobre Mí</Link>
          <Link to="/portfolio" className="inicio-link">Portfolio</Link>
          <Link to="/contacto" className="inicio-link">Contacto</Link>
        </nav>

        <div className="scroll-down-icon">↓</div>
      </div>
    </section>
  );
}

export default Inicio;
